import React, { useMemo } from 'react';
import { getSpotheroOversizeFee } from 'utils/search-vehicle';
import { useSelector } from 'react-redux';
import { getSelectedSpotById, getVehicleInfo } from 'store/spots/spots-selectors';
import useOversizeEnabled from 'hooks/use-oversize-enabled';
import OversizeVehicleWarning from './OversizeVehicleWarning';
import OversizeNoVehicleSetWarning from './OversizeNoVehicleSetWarning';
import OversizeVehicleErrorAlert from './OversizeVehicleErrorAlert';
const VehicleBanner = ({ showVehicleErrorBanner }) => {
    const isOversizeEnabled = useOversizeEnabled();
    const selectedSpot = useSelector(getSelectedSpotById);
    const vehicle = useSelector(getVehicleInfo);
    const oversizeFee = useMemo(() => (selectedSpot ? getSpotheroOversizeFee(selectedSpot) : null), [selectedSpot]);
    const supportsOversizeFee = selectedSpot?.supportedFeeTypes?.includes('oversize_fee');
    const isSpotAvailable = selectedSpot?.availability?.available;
    const unavailableReasonDueToOversize = !isSpotAvailable
        ? selectedSpot?.availability?.unavailableReasons?.includes('Vehicle Size Exceeded')
        : '';
    const noOversizeInfoSet = !isOversizeEnabled ||
        !supportsOversizeFee ||
        // when error set but is not due to oversize
        (!isSpotAvailable && !unavailableReasonDueToOversize);
    // Show error if spot unavailable due to oversize
    if (showVehicleErrorBanner || unavailableReasonDueToOversize) {
        return <OversizeVehicleErrorAlert vehicle={vehicle}/>;
    }
    if (noOversizeInfoSet) {
        return null;
    }
    // Show info to set vehicle if none set and oversize fee supported
    if (!vehicle && supportsOversizeFee) {
        return <OversizeNoVehicleSetWarning />;
    }
    // Show warning if oversize fee applies
    if (oversizeFee?.isOversize) {
        return (<OversizeVehicleWarning oversizeFee={oversizeFee} vehicle={vehicle}/>);
    }
    return null;
};
export default VehicleBanner;
